import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faRotate, faShirt, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { imageQueueLabel, imageQueueWait } from "../../utils/imageQueueLabel";
import styles from "./Wardrobe.module.css";
import { categoryLabel, imageUrl } from "./wardrobeConstants";

function ClothingItemDetails({ item, deleting, onClose, onEdit, onDelete, onGenerateImage }) {
  const queued = ["queued", "pending", "processing"].includes(item.image_generation_status);
  const details = [
    ["Categoria", categoryLabel(item.category)], ["Subcategoria", item.subcategory],
    ["Cor", item.color], ["Estampa", item.pattern], ["Material", item.material],
    ["Marca", item.brand], ["Descrição", item.description],
  ].filter(([, value]) => value);

  return (
    <div className={styles.backdrop} role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className={styles.detailModal} role="dialog" aria-modal="true" aria-labelledby="item-detail-title">
        <button type="button" className={`${styles.iconButton} ${styles.detailClose}`} onClick={onClose} aria-label="Fechar"><FontAwesomeIcon icon={faXmark} /></button>
        <div className={styles.detailImage}>{queued ? <span className={styles.queuePlaceholder}><FontAwesomeIcon icon={faShirt} /><strong>Fila de Processamento</strong><small>{imageQueueLabel(item.image_queue)}</small><small>{imageQueueWait(item.image_queue)}</small><small>Sua imagem será gerada assim que houver disponibilidade.</small></span> : item.image_url && item.image_origin !== "source_photo" ? <img src={imageUrl(item.image_url)} alt={item.name} /> : <span className={styles.placeholder}><FontAwesomeIcon icon={faShirt} /></span>}</div>
        <div className={styles.detailContent}>
          <p className={styles.eyebrow}>{"Detalhes da peça"}</p><h2 id="item-detail-title">{item.name}</h2>
          <dl>{details.map(([label, value]) => <div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}</dl>
          <div className={styles.detailActions}>
            {((!item.image_url && item.source_post_id) || item.image_origin === "source_photo") && !queued && <button type="button" onClick={onGenerateImage}><FontAwesomeIcon icon={faRotate} /> Gerar imagem da peça</button>}
            <button type="button" onClick={onEdit}><FontAwesomeIcon icon={faPen} /> Editar</button>
            <button type="button" className={styles.deleteButton} onClick={onDelete} disabled={deleting}><FontAwesomeIcon icon={faTrash} /> {deleting ? "Removendo..." : "Excluir peça"}</button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ClothingItemDetails;
